import React from "react";
import { ReactComponent as DollarIcon } from "@/assets/img/dollar_icon.svg";
import { ReactComponent as RielIcon } from "@/assets/img/riel_icon.svg";
import { numberFormatter } from "@/util/formatter";
import styles from "./styles.module.scss";

export default function CurrenciesCard({
  title,
  khrBalance,
  usdBalance,
  ...others
}) {
  return (
    <div className={styles.currenciesCard} {...others}>
      <h4 className={styles.title}>{title}</h4>
      <div className={styles.balance}>
        <RielIcon className={styles.rielIcon} />
        {numberFormatter(khrBalance, 0)}
      </div>
      <div className={styles.balance}>
        <DollarIcon className={styles.dollarIcon} />
        {numberFormatter(usdBalance, 2)}
      </div>
    </div>
  );
}
